<template>
    <div class="container-fluid">
        <div
            class="row"
            v-if="loading"
        >
            <div class="col-sm-12">
                Loading
                <i class="fa fa-spinner fa-spin" />
            </div>
        </div>

        <div
            class="row"
            v-if="!loading && !forms.length"
        >
            <div class="col-sm-12">
                No CPD Forms
            </div>
        </div>

        <div class="row">
            <div
                v-for="form in forms"
                :key="form.id"
                class="col-lg-4 col-sm-12"
            >
                <div class="card">
                    <router-link
                        class="card-body"
                        style="cursor:pointer;"
                        tag="div"
                        :to="{name: 'engineer.cpc-forms.edit', params: {id: form.id}}"
                    >
                        <p class="text-info">
                            {{ form.form_date.format('Do MMM YYYY') }}
                        </p>
                        <h2>{{ form.title }}</h2>
                        <p>{{ form.hours }} hours</p>
                        <p v-if="user.admin_access">
                            {{ form.user.name }}
                        </p>
                    </router-link>
                </div>
            </div>
        </div>
        <router-link
            class="btn new-job-btn floating-new-btn"
            :to="{name: 'engineer.cpc-forms.new'}"
        >
            <i class="fa fa-plus" />
        </router-link>
    </div>
</template>

<script>
import CPCFormService from "../../../services/CPCFormService";
import Auth from "../../../mixins/Auth";

export default {
    mixins: [
        Auth,
    ],
    data: function () {
        return {
            loading: false,
            forms: [],
        };
    },

    watch: {
        userId: {
            handler: function () {
                this.loading = true;
                CPCFormService.index()
                    .then(response => {
                        this.forms = response.data.map(form => ({
                            ...form,
                            form_date: window.moment(form.form_date),
                        }));
                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;
                        console.error(error);
                    });
            },
            immediate: true,
        }
    },

    mounted: function () {

    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/engineer/cpc-forms/IndexComponent.vue